export default "__VITE_ASSET__C9t5Qaww__"